import React, { useState, useEffect } from "react";
import '../componentsCss/EditarProcedimentos.css';

export default function EditarProcedimento({ procedimento, onOpen, onClose, onPriceUpdated, onProcedureUpdated }) {
    const [name, setName] = useState("");
    const [cost_price, setCost_price] = useState("");
    const [selling_price, setSelling_price] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (procedimento && onOpen) {
            setName(procedimento.name || "");
            setCost_price(procedimento.cost_price || "");
            setSelling_price(procedimento.selling_price || "");
        } else {
            setName("");
            setCost_price("");
            setSelling_price("");
        }
    }, [procedimento, onOpen]);

    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // Atualiza os preços no estado de ProcedimentosModal
            onPriceUpdated(procedimento.id, parseFloat(cost_price), parseFloat(selling_price));
    
            // Atualiza o procedimento no estado da lista de procedimentos
            onProcedureUpdated({
              ...procedimento,
              cost_price: parseFloat(cost_price),
              selling_price: parseFloat(selling_price),
            });
    
            setLoading(false);
            onClose();
        } catch (error) {
            console.error("Erro ao atualizar o procedimento", error);
            setLoading(false);
        }
    };
    
    
    
    if (!onOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content-procedure">
                <h1>Editar Procedimento</h1>
                <div>
                    <div className="form-group">
                        <label>Nome</label>
                        <input
                            type="text"
                            disabled
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Nome do procedimento"
                        />
                    </div>
                    <div className="form-group">
                        <label>Preço de Custo:</label>
                        <input
                            type="number"
                            value={cost_price}
                            onChange={(e) => setCost_price(e.target.value)}
                            placeholder="Preço do procedimento"
                        />
                    </div>
                    <div className="form-group">
                        <label>Preço de Venda:</label>
                        <input
                            type="number"
                            value={selling_price}
                            onChange={(e) => setSelling_price(e.target.value)}
                            placeholder="Preço do procedimento"
                        />
                    </div>

                    <div className="button-group">
                        <button onClick={handleSubmit} disabled={loading}>
                            {loading ? "Salvando..." : "Salvar"}
                        </button>
                        <button type="button" onClick={onClose}>
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
